/**
 * onboardingRecsPrefetch.ts — start the firm-aware recommendation generation
 * IN PARALLEL with account setup (2026-08-04 owner feedback: chip
 * pre-selection on the profile page took 10-15s because the model call only
 * started when that page mounted).
 *
 * Fired fire-and-forget the moment a trial_start redemption succeeds — the
 * ~10-15s generation then overlaps the "code applied" redirect and the
 * onboarding bootstrap, and the server caches the result per firm-profile
 * hash (users/{uid}/onboarding/recommendations). The profile page's own
 * fetch — which sends the IDENTICAL option lists from
 * src/data/onboardingOptions.ts — becomes a warm cache hit.
 *
 * Best-effort by contract: any failure is silent; the profile page's normal
 * request path still covers generation.
 */

import { getAuth } from 'firebase/auth';
import { DEFAULT_PRACTICE_OPTIONS, buildCapabilityUniverse } from '../data/onboardingOptions';

function getProjectId(): string {
  return process.env.REACT_APP_FIREBASE_PROJECT_ID || 'tensile-tenure-453409-k3';
}

export function prefetchOnboardingRecommendations(): void {
  void (async () => {
    try {
      const user = getAuth().currentUser;
      if (!user) return;
      const token = await user.getIdToken();
      await fetch(`https://us-central1-${getProjectId()}.cloudfunctions.net/getOnboardingRecommendations`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          workAreaOptions: DEFAULT_PRACTICE_OPTIONS,
          capabilityOptions: buildCapabilityUniverse(),
        }),
      });
    } catch { /* best-effort — the onboarding page's own fetch still runs */ }
  })();
}
